export enum SocialButtonType {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  INSTAGRAM = 'instagram',
  INSTAGRAM_BASIC = 'instagramBasic',
  LINKEDIN = 'linkedin',
  TIKTOK = 'tiktok',
  YOUTUBE = 'youtube',
  TELEGRAM = 'telegram',
  DISCORD = 'discord',
  TWITCH = 'twitch',
  PINTEREST = 'pinterest',
  SNAPCHAT = 'snapchat',
  MEDIUM = 'medium',
  ONLYFANS = 'onlyfans',
  BEEHIIV = 'beehiiv',
  SUBSTACK = 'substack',
  IMDB = 'imdb',
  BEHANCE = 'behance',
}

export enum SocialButtonModel {
  SQUARE = 'square',
  ROUNDED = 'rounded',
}
